import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import ArrowCardIcon from './ArrowCardIcon';
import {
  cardShadow, cardShadowHover, helpColors, helpEase,
} from '../style/helpStyles';

const ChannelCard = ({
  label, value, href, Icon, isExternal,
}) => (
  <Box
    component="a"
    href={href}
    target={isExternal ? '_blank' : undefined}
    rel={isExternal ? 'noopener noreferrer' : undefined}
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      height: '100%',
      textDecoration: 'none',
      backgroundColor: helpColors.white,
      borderRadius: '20px',
      padding: '16px 18px',
      boxShadow: cardShadow,
      transition: `transform .35s ${helpEase}, box-shadow .35s ${helpEase}`,
      '&:hover': { transform: 'translateY(-3px)', boxShadow: cardShadowHover },
      '&:hover .help-channel-icon': { transform: 'scale(1.08)' },
    }}
  >
    <Box
      className="help-channel-icon"
      sx={{
        width: 50,
        height: 50,
        flexShrink: 0,
        borderRadius: '999px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: helpColors.pink50,
        color: helpColors.pink,
        transition: `transform .35s ${helpEase}`,
      }}
    >
      <Icon sx={{ fontSize: 26 }} />
    </Box>
    <Box sx={{
      flex: 1, display: 'flex', flexDirection: 'column', textAlign: 'left',
    }}
    >
      <Typography component="span" sx={{ fontWeight: 600, fontSize: 15, color: helpColors.ink }}>
        {label}
      </Typography>
      <Typography component="span" sx={{ fontSize: 13, color: helpColors.ink3, marginTop: '2px' }}>
        {value}
      </Typography>
    </Box>
    <ArrowCardIcon sx={{ fontSize: 16 }} />
  </Box>
);

ChannelCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  isExternal: PropTypes.bool,
};

ChannelCard.defaultProps = {
  isExternal: false,
};

export default ChannelCard;
